import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconAlert from 'components/common/IconAlert';
import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Alert, Badge, Button, Card, Col, FloatingLabel, Form, ListGroup, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import { toast } from 'react-toastify';
import { useToast } from 'context/providers/ToastProvider';
import useToken from '../../hooks/useToken';
import CopyButton from '../servicio/CopyButton';
import ModalActivarNube from './ModalActivarNube';
import ModalDesactivarLicencia from './ModalDesactivarLicencia';
import ModalRenovarLicencia from './ModalRenovarLicencia';
import ModalActivarAkasiaPOS from './ModalActivarAkasiaPOS';

const SeccionDatosLicencia = (
    {
        idLicencia,
        licencias,

        procesandoModal,
        setProcesandoModal,
        editar,
        setEditar,

        getInformacionDetalladaLicenciaByID,

        vendedores,

        tipoLicencia,

        cicloFacturacion,


        setPolizasRelacionadas,

        usuariosNube,
        setUsuariosNube,

        akasiaPOSWebPaquetes,
        infoSuscripcion
    }
) => {

    /**
    * AUTENTICACION
    */
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();
    const { reset, handleSubmit, register, setValue, formState: { errors } } = useForm();
    const { reset: resetDias, handleSubmit: handleSubmitDias, register: registerDias, watch: watchDias, formState: { errors: errorsDias } } = useForm({ defaultValues: { iNumeroDias: 5 } });
    const [datosPCAutorizar, setDatosPCAutorizar] = useState([]);
    const [showCambiarPCAutorizada, setShowCambiarPCAutorizada] = useState(false);
    const [showModalAsignarDias, setShowModalAsignarDias] = useState(false);
    const [showModalAsignarDiasTipo7, setShowModalAsignarDiasTipo7] = useState(false);
    const [showModalActivarNube, setShowModalActivarNube] = useState(false);
    const [showModalActivarAkasiaPOS, setShowModalActivarAkasiaPOS] = useState(false);
    const [showModalActivar, setShowModalActivar] = useState(false);

    const [showModalRenovar, setShowModalRenovar] = useState(false);
    const [showModalDesactivar, setShowModalDesactivar] = useState(false);
    const [tipoPolizas, setTipoPolizas] = useState([]);
    const [licenciasServidor, setLicenciasServidor] = useState([]);

    const [showCambiarServidor, setShowCambiarServidor] = useState(false);
    const [servidoresDisponibles, setServidoresDisponibles] = useState([]);
    const [cargandoServidores, setCargandoServidores] = useState(false);
    const [servidorSeleccionado, setServidorSeleccionado] = useState("");

    const recargarPolizasYDatos = async () => {
        await getInformacionDetalladaLicenciaByID();
        try {
            const response = await fetch(`/api/licencia/ObtenerDatosServiciosRelacionados/?id=${idLicencia}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType == 1) {
                    var ObjDetalles = JSON.parse(data.detalles);
                    setPolizasRelacionadas(ObjDetalles.table2);
                }
            }
        } catch (error) {
            console.error('Error al recargar polizas:', error);
        }
    };

    const obtenerServidoresActivosCliente = async () => {
        try {
            setCargandoServidores(true);
            const response = await fetch(`/api/licencia/ObtenerLicenciasActivasCliente?idClienteAkasia=${licencias.idClienteAkasia}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                const servidores = data.filter(lic => lic.idCatTipoLicencia === 1);
                setServidoresDisponibles(servidores);

                let currentUUID = "";
                try {
                    if (licencias.vConfiguracion) {
                        const config = JSON.parse(licencias.vConfiguracion);
                        currentUUID = config.vUUIDServidor || "";
                    }
                } catch (e) {
                    console.error("Error parsing vConfiguracion:", e);
                }
                setServidorSeleccionado(currentUUID);
            } else {
                showErrorToast("Error al cargar los servidores del cliente");
            }
        } catch (error) {
            console.error("Error fetching active licenses:", error);
            showErrorToast("Error al cargar los servidores del cliente");
        } finally {
            setCargandoServidores(false);
        }
    };

    const guardarNuevoServidor = async () => {
        if (!servidorSeleccionado) {
            showErrorToast("Debe seleccionar una licencia servidor");
            return;
        }

        const selectedServer = servidoresDisponibles.find(srv => srv.vUUIDLicencia === servidorSeleccionado);
        const idLicenciaServidorNuevo = selectedServer ? selectedServer.idLicencia : 0;

        try {
            setProcesandoModal(true);
            const response = await fetch(`/api/licencia/ActualizarServidorVinculado?idLicencia=${idLicencia}&vUUIDServidorNuevo=${encodeURIComponent(servidorSeleccionado)}&idLicenciaServidorNuevo=${idLicenciaServidorNuevo}`, {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(data.vMessage || "Servidor actualizado con éxito");
                    setShowCambiarServidor(false);
                    await recargarPolizasYDatos();
                } else {
                    showErrorToast(data.vMessage || "Error al actualizar servidor");
                }
            } else {
                showErrorToast("Error al comunicarse con el servidor");
            }
        } catch (error) {
            console.error("Error saving new server:", error);
            showErrorToast("Error al actualizar servidor");
        } finally {
            setProcesandoModal(false);
        }
    };

    const hasSubscription = infoSuscripcion && ((Array.isArray(infoSuscripcion) && infoSuscripcion.length > 0) || infoSuscripcion.idSuscripcion);



    /**
    * Submit de guardar
    * @param {any} data
    */
    const onSubmit = async (data) => {
        try {
            console.log("data: ", data);

            setProcesandoModal(true);
            var vConfiguracion = {
                vIdentificador: data.vIdentificador,
                vUsuario: data.vUsuario,
                vContrasena: data.vContrasena,
                vBD: data.vBD
            }
            data.vConfiguracion = JSON.stringify(vConfiguracion);
            if (data.vConfiguracion == '{}')
                data.vConfiguracion = '';
            enviarInfoToServer(JSON.stringify(data, null, 2));
        } catch (e) {
            console.log(e)
        }

    };

    /**
   * Submit de asignar dias
   * @param {any} data
   */
    const onSubmitAsignarDias = data => {
        console.log('>>> [onSubmitAsignarDias] LLAMADO — validaciones PASARON');
        console.log('>>> data.iNumeroDias:', data.iNumeroDias, '| tipo:', typeof data.iNumeroDias);
        console.log('>>> licencias.idCatTipoLicencia:', licencias.idCatTipoLicencia, '| tipo:', typeof licencias.idCatTipoLicencia);
        setProcesandoModal(true);
        asignarDiasLicenciaPrueba(data.iNumeroDias);
    };


    /**
     * Este metodo aumenta el numero de dias del periodo de prueba
     * @param {any} iNumeroDias
     */
    const asignarDiasLicenciaPrueba = async (iNumeroDias) => {
        const response = await fetch("/api/licencia/asignardiaslicenciaprueba/?id=" + idLicencia + "&iNumeroDias=" + iNumeroDias, {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            //getInformacionDetalladaLicenciaByID();

            licencias.dFinLicenciaUso = data["table2"][0].dFinLicenciaUso;
            licencias.dDiasFaltantes = data["table2"][0].dDiasFaltantes;

            showSuccessToast(data["table1"][0].vMessage);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalAsignarDias(false);
        setShowModalAsignarDiasTipo7(false);
        setProcesandoModal(false);
        resetDias();
    };



    /**
 * Submit de activar
 * @param {any} data
 */
    const onSubmitActivar = data => {
        setProcesandoModal(true);
        if (data.idCatCicloFacturacion == 4 && licencias.idCatTipoLicencia == 3) {
            toast.error('No es posible asignar un ciclo de facturaci\u00F3n permanente a este tipo de licencia', {
                theme: 'colored',
                position: "bottom-left"
            });
            setProcesandoModal(false);
        }
        else
            activarLicencia(JSON.stringify(data));
    };



    /**
     * Activar licencia
     * @param {any} values
     */
    const activarLicencia = async (values) => {
        console.log(values);
        const response = await fetch("/api/licencia/activarlicencia/?id=" + idLicencia + "&values=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data["table1"][0].iResponseType == 1) {

                //se actualizan unicamente los campos modificados.
                licencias.bIsPeriodoPrueba = data["table2"][0].bIsPeriodoPrueba;
                licencias.dUpdatedDate = data["table2"][0].dUpdatedDate;
                licencias.vUpdatedUser = data["table2"][0].vUpdatedUser;
                licencias.dInicioLicenciaUso = data["table2"][0].dInicioLicenciaUso;
                licencias.dDiasTranscurridos = data["table2"][0].dDiasTranscurridos;
                licencias.dFinLicenciaUso = data["table2"][0].dFinLicenciaUso;
                licencias.dDiasFaltantes = data["table2"][0].dDiasFaltantes;
                licencias.idCatCicloFacturacion = data["table2"][0].idCatCicloFacturacion;
                licencias.vLatLon = data["table2"][0].vLatLon;
                licencias.vConfiguracion = data["table2"][0].vConfiguracion;
                setPolizasRelacionadas(data["table3"]);

                showSuccessToast(data["table1"][0].vMessage);
            }
            else {
                showErrorToast(data["table1"][0].vMessage);
            }


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowModalActivar(false);
        setProcesandoModal(false);
        reset();
    };


    /**
  * Obtener Lista de Pc Login
  */
    const obtenerListaPCLogIn = async () => {
        const response = await fetch("/api/licencia/ObtenerListaPCsInicioSesion/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setDatosPCAutorizar(data)
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    /**
 * Submit de PC Autorizada
 * @param {any} data
 */
    const onSubmitAsignarPCAutorizada = data => {
        console.log(data.vDatosPCAutorizada);
        asignarPCAutorizada(data.vDatosPCAutorizada);
    };


    /**
     * Asingar PC Autorizada
     * @param {any} vDatosPCAutorizada
     */
    const asignarPCAutorizada = async (vDatosPCAutorizada) => {
        console.log(vDatosPCAutorizada);
        const response = await fetch("/api/licencia/asignarPCAutorizada/?id=" + idLicencia + "&vDatosPCAutorizada=" + encodeURIComponent(vDatosPCAutorizada), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            // Actualizar el estado local con la nueva PC autorizada


            getInformacionDetalladaLicenciaByID()
            //setLicencias(prevState => ({
            //    ...prevState,
            //    vDatosPCAutorizada: vDatosPCAutorizada
            //}));            
            showSuccessToast(data[0].vMessage);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowCambiarPCAutorizada(false);
        setProcesandoModal(false);
        reset();
    };

    /**
    * Enviar informacion
    * @param {any} values
    */
    const enviarInfoToServer = async (values) => {

        var jsonToSend = [];
        jsonToSend.push(JSON.parse(values));

        console.log("jsonToSend: ", jsonToSend);

        const response = await fetch("/api/licencia/EditarLicencia/", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jsonToSend)
        })
            .catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("==== EDITAR DATOS LICENCIA ====");
            console.log("response: ", response);

            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var detalles = JSON.parse(data.detalles);
                detalles = detalles[0];
                console.log("detalles: ", detalles);

                licencias.idCatTipoLicencia = detalles.idCatTipoLicencia;
                licencias.vNombreVendedor = detalles.vNombreVendedor;
                licencias.vUUIDEmpresa = detalles.vUUIDEmpresa;
                licencias.idCatCicloFacturacion = detalles.idCatCicloFacturacion;
                licencias.vComentarios = detalles.vComentarios;
                licencias.vLatLon = detalles.vLatLon;
                licencias.vDescripcionTipo = detalles.vDescripcionTipo;
                licencias.vDescripcionCiclo = detalles.vDescripcionCiclo;
                licencias.iNumeroDias = detalles.iNumeroDias;

                showSuccessToast(data.vMessage);

                setEditar(false);
            }
            else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);

            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        // setCargando(false);
        setProcesandoModal(false);

    };

    /**
    * verifica la orden de pago de la licencia
    * Este metodo comprueba que la licencia esté vinculada a una orden.
    * @param {any} tipolicencia
    */
    const verificarOrdenPagoLicencia = async (tipolicencia) => {

        //console.log(tipolicencia);
        var _tipoLicencia = tipolicencia;
        var objDataSend = {};
        objDataSend.idLicencia = idLicencia;

        console.log(objDataSend);
        var jDataSend = JSON.stringify(objDataSend);

        const response = await fetch("/api/licencia/VerificarOrdenPagoLicencia", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {
                if (_tipoLicencia == 3) {
                    setShowModalActivarNube(true);

                }
                else
                    if (_tipoLicencia == 7) {
                        setShowModalActivarAkasiaPOS(true);
                    }
                    else {

                        setShowModalActivar(true);

                        //console.log("Entra si tipo licencia no es 3");
                    }
            }

            if (data.iResponseType == 3) {
                //Se peude mejorar esta condicion, mostrando un modal con las ordenes que puedan vincularse a esta licencia, ahorrando tiempo.
                toast.error(data.vMessage, {
                    theme: 'colored',
                    position: "bottom-right",
                    limit: 1
                });
            }

            if (data.iResponseType == 2) {
                showErrorToast('Ocurrio un error:' + data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {//si no tiene autorizacion hay que setear com nulo el token
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    /**
    * Obtiene informacion de catalogos
    */
    const ObtenerInformacionPolizasServidores = async () => {

        // setCargando(true);
        const response = await fetch("/api/licencia/ObtenerInformacionPolizasServidores/?idLicencia=" + idLicencia, {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {

            console.log("==== DETALLES INFORMACION LICENCIA ====");

            console.log(response);
            const data = await response.json();

            //detalles de polizas
            console.log(data['table1']);
            setTipoPolizas(data['table1']);


            //licencias servidores
            console.log(data['table2']);
            setLicenciasServidor(data['table2']);


            //se cambia estado de cargando
            // setCargando(false);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            //setCargando(false);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };
    return (
        <>
            <Card className="fs--1">
                <Card.Header>
                    <Row className="align-items-center">
                        <Col xs={2} sm={3} md={3} lg={2}>
                            {licencias.idCatTipoLicencia == 1 &&
                                <img src="/img/servidor48.png"></img>}
                            {licencias.idCatTipoLicencia == 2 &&
                                <img src="/img/caja48.png"></img>}
                            {licencias.idCatTipoLicencia == 3 &&
                                <img src="/img/nube48.png"></img>}
                        </Col>
                        <Col>

                            <h5 className="mb-0">Datos de licencia</h5>
                        </Col>
                        <Col xs="auto">
                            {licencias.bIsActive &&
                                !licencias.bCancelado &&
                                !editar &&
                                licencias.idCatTipoLicencia != 7 &&
                                <IconButton
                                    onClick={() => { setEditar(true) }}
                                    iconClassName="fs--2 me-1"
                                    variant="falcon-default"
                                    size="sm"
                                    icon="pencil-alt"
                                >
                                    Editar licencia
                                </IconButton>
                            }

                            {editar &&
                                <IconButton
                                    onClick={() => { setEditar(false); reset() }}
                                    iconClassName="fs--2 me-1"
                                    variant="falcon-default"
                                    size="sm"
                                    icon={faWindowClose}

                                >
                                    Cancelar edici&oacute;n
                                </IconButton>
                            }
                        </Col>
                    </Row>
                </Card.Header>

                <Card.Body className="border-top">
                    {
                        editar ? (
                            <>
                                <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Vendedor</Form.Label>
                                        <Form.Select
                                            aria-label="Default select"
                                            defaultValue={JSON.stringify({ vUsuario: licencias.vNombreVendedor, idUsuario: licencias.idUsuario })}
                                            isInvalid={!!errors.vNombreVendedor}
                                            {...register("vNombreVendedor",
                                                {
                                                    required: true
                                                })
                                            }
                                        >
                                            <option value="">Selecciona un vendedor</option>
                                            {vendedores.map((vendedor, index) => {
                                                const value = JSON.stringify({ vUsuario: vendedor.vUsuario, idUsuario: vendedor.idUsuario });//json con 2 values, idUsuario y vUsuario
                                                return (
                                                    <option
                                                        key={index}
                                                        value={value}>
                                                        {vendedor.vUsuario} - {vendedor.vNombre} {vendedor.vApellidos}
                                                    </option>)
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>UUID Empresa</Form.Label>
                                        <Form.Control
                                            type="hidden"
                                            defaultValue={licencias.idLicencia}
                                            {...register("idLicencia")}
                                        />
                                        <Form.Control
                                            autoComplete="off"
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            type="text"
                                            defaultValue={licencias.vUUIDEmpresa}
                                            placeholder="vUUIDEmpresa"
                                            isInvalid={!!errors.vUUIDEmpresa}
                                            {...register("vUUIDEmpresa",
                                                {
                                                    required: 'El vUUIDEmpresa es requerido',
                                                    pattern: /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
                                                    maxLength: 36,
                                                    minLength: 36
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vUUIDEmpresa && errors.vUUIDEmpresa.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo Licencia</Form.Label>
                                        <Form.Select
                                            aria-label="Default select"
                                            defaultValue={licencias.idCatTipoLicencia}
                                            isInvalid={!!errors.idCatTipoLicencia}
                                            {...register("idCatTipoLicencia",
                                                {
                                                    required: true
                                                })
                                            }
                                        >

                                            {tipoLicencia.map((licencia, index) => {
                                                if (licencias.idCatTipoLicencia == 1 || licencias.idCatTipoLicencia == 2)
                                                    return (<option key={index} value={licencia.idCatTipoLicencia}>{licencia.vDescripcionTipo}</option>)

                                            })}

                                            {
                                                licencias.idCatTipoLicencia != 1 && licencias.idCatTipoLicencia != 2 &&
                                                <>
                                                    <option value={licencias.idCatTipoLicencia}>{licencias.vDescripcionTipo}</option>
                                                </>

                                            }

                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.idCatTipoLicencia && errors.idCatTipoLicencia.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Ciclo facturaci&oacute;n</Form.Label>
                                        <Form.Select
                                            aria-label="Default select"
                                            defaultValue={licencias.idCatCicloFacturacion}
                                            isInvalid={!!errors.idCatCicloFacturacion}
                                            {...register("idCatCicloFacturacion",
                                                {
                                                    required: true
                                                })
                                            }
                                        >
                                            {cicloFacturacion.map((ciclo, index) => {
                                                return (<option key={index} value={ciclo.idCatCicloFacturacion}>{ciclo.vDescripcionCiclo} - {ciclo.iNumeroDias} d&iacute;as</option>)
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.idCatCicloFacturacion && errors.idCatCicloFacturacion.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {licencias.idCatTipoLicencia != 3 &&
                                        <Form.Group className="mb-3" >
                                            <Form.Label>vLatLon {licencias.vLatLonSistema && <a href="#" onClick={() => setValue("vLatLon", licencias.vLatLonSistema)}>{licencias.vLatLonSistema}</a>} </Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                defaultValue={licencias.vLatLon}
                                                placeholder="vLatLon"
                                                isInvalid={!!errors.vLatLon}
                                                {...register("vLatLon",
                                                    {
                                                        required: 'El vLatLon es requerido',
                                                        pattern: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vLatLon && errors.vLatLon.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    }
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Agregar un mensaje para el cliente</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            autoComplete="off"
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            defaultValue={licencias.vComentarios}
                                            placeholder="Comentario"
                                            isInvalid={!!errors.vComentarios}
                                            {...register("vComentarios",
                                                {
                                                    maxLength: 1000
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vComentarios && errors.vComentarios.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Row>
                                        <Col>
                                            &nbsp;
                                        </Col>
                                        <Col xs="auto">
                                            {editar &&
                                                <IconButton
                                                    className="ms-2"
                                                    iconClassName="fs--2 me-1"
                                                    variant="falcon-default"
                                                    size="sm"
                                                    icon="check"
                                                    type="submit"
                                                >
                                                    Guardar Cambios
                                                </IconButton>
                                            }
                                        </Col>
                                    </Row>
                                </Form>
                            </>
                        ) : (
                            <>
                                <Table responsive striped hover size="sm" >
                                    <tbody>
                                        <tr>
                                            <td><strong>VENDEDOR:</strong></td>
                                            <td><img src="/img/vendedor35.png"></img>&nbsp;&nbsp;{licencias.vNombreVendedor}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>UUID LICENCIA:</strong></td>
                                            <td>
                                                <Row>
                                                    <Col>
                                                        {licencias.vUUIDLicencia}
                                                    </Col>
                                                    <Col xs="auto">
                                                        <CopyButton code={licencias.vUUIDLicencia} />
                                                    </Col>
                                                </Row>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>UUID EMPRESA:</strong></td>
                                            <td>
                                                <Row>
                                                    <Col>
                                                        {licencias.vUUIDEmpresa}
                                                    </Col>
                                                    <Col xs="auto">
                                                        <CopyButton code={licencias.vUUIDEmpresa} />
                                                    </Col>
                                                </Row>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td><strong>COPIAR CLAVE DE VALIDACI&Oacute;N:</strong></td>
                                            <td>
                                                <Row>
                                                    <Col>
                                                        ***************
                                                        ***************
                                                        ***************
                                                    </Col>
                                                    <Col xs="auto">
                                                        <CopyButton code={licencias.vClaveValidacion} />
                                                    </Col>
                                                </Row>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>TIPO LICENCIA:</strong></td>
                                            <td> {licencias.vDescripcionTipo} </td>
                                        </tr>
                                        <tr>
                                            <td><strong>CICLO FACTURACI&Oacute;N:</strong></td>
                                            <td>{licencias.vDescripcionCiclo} - {licencias.iNumeroDias} d&iacute;as</td>
                                        </tr>
                                        <tr>
                                            <td><strong>ESTATUS:</strong></td>
                                            <td>
                                                {licencias.bCancelado ? (
                                                    <Row className="align-items-center">
                                                        <Col>
                                                            <Badge bg='danger' className='me-2'>C A N C E L A D A </Badge>
                                                            <Alert variant="danger">
                                                                <p className="fs--1"><b>MOTIVO:</b> {licencias.vMotivoCancelacion}</p>
                                                                <p className="fs--1"><b>CANCEL&Oacute;:</b> {licencias.vUsuarioCancelador}</p>
                                                            </Alert>
                                                        </Col>

                                                    </Row>
                                                ) : (licencias.bIsPeriodoPrueba ?
                                                    (<Row className="align-items-center">
                                                        <Col>
                                                            <img src="/img/noactivo.png"></img>
                                                            &nbsp;&nbsp;<Badge bg='danger' className='me-2'> {!licencias.idOrden ? "P R U E B A" : "NO ACTIVADA"} </Badge>

                                                        </Col>
                                                        <Col xs="auto">
                                                            {licencias.bIsActive &&
                                                                <>
                                                                    {licencias.idCatTipoLicencia == 1 &&
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => { verificarOrdenPagoLicencia(1); }}
                                                                            variant='falcon-success'
                                                                            className='me-2 mb-1'>Activar</Button>
                                                                    }
                                                                    {licencias.idCatTipoLicencia == 2 &&
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => { verificarOrdenPagoLicencia(2); }}
                                                                            variant='falcon-success'
                                                                            className='me-2 mb-1'>Activar</Button>
                                                                    }

                                                                    {licencias.idCatTipoLicencia == 3 &&
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => { verificarOrdenPagoLicencia(3); }}
                                                                            variant='falcon-success'
                                                                            className='me-2 mb-1'>Activar</Button>
                                                                    }
                                                                    {licencias.idCatTipoLicencia == 4 &&
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => { verificarOrdenPagoLicencia(4); }}
                                                                            variant='falcon-success'
                                                                            className='me-2 mb-1'>Activar</Button>
                                                                    }
                                                                    {licencias.idCatTipoLicencia == 7 && !hasSubscription &&
                                                                        <Button
                                                                            size="sm"
                                                                            onClick={() => { verificarOrdenPagoLicencia(7); }}
                                                                            variant='falcon-success'
                                                                            className='me-2 mb-1'>Activar</Button>
                                                                    }
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    ) : (licencias.dDiasFaltantes > 0 ?
                                                        <Row>
                                                            <Col>
                                                                {licencias.idCatTipoLicencia == 3 ?
                                                                    <img src="/img/nubeActiva.png"></img> : <img src="/img/activo.png"></img>}
                                                                &nbsp;&nbsp;<Badge bg='success' className='me-2'>A C T I V A</Badge>
                                                            </Col>
                                                            <Col xs="auto">
                                                                <Button
                                                                    className="mt-2"
                                                                    size="sm"
                                                                    onClick={() => { setShowModalDesactivar(true) }}
                                                                    variant='falcon-danger'>Desactivar</Button>
                                                                {licencias.idCatCicloFacturacion < 4 && licencias.idCatTipoLicencia != 7 &&
                                                                    <>
                                                                        &nbsp;&nbsp;<Button
                                                                            className="mt-2"
                                                                            size="sm"
                                                                            onClick={() => { setShowModalRenovar(true); }}
                                                                            variant='falcon-success'>Renovar</Button>
                                                                    </>}
                                                            </Col>
                                                        </Row>

                                                        :
                                                        <Row>
                                                            <Col>
                                                                {licencias.idCatTipoLicencia == 3 ?
                                                                    <img src="/img/nubeVencida.png"></img> : <img src="/img/noactivo.png"></img>}

                                                                &nbsp;&nbsp;<Badge bg='danger' className='me-2'>V E N C I D A</Badge>
                                                            </Col>
                                                            <Col xs="auto">
                                                                {licencias.idCatTipoLicencia != 7 &&
                                                                    <Button
                                                                        onClick={() => { setShowModalRenovar(true); }}
                                                                        variant='falcon-success'>Renovar</Button>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    )
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>INICIO LICENCIA:</strong></td>
                                            <td>
                                                {licencias.dInicioLicenciaUso}&nbsp;
                                                <SoftBadge pill bg='primary' className='me-2'>hace {licencias.dDiasTranscurridos} d&iacute;as  <FontAwesomeIcon icon="clock" className="ms-2" /></SoftBadge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td> <strong> FIN LICENCIA: </strong> </td>
                                            <td>
                                                <Row className="align-items-center">
                                                    <Col >
                                                        {licencias.dFinLicenciaUso}  <SoftBadge pill bg="warning">
                                                            restan  {licencias.dDiasFaltantes} d&iacute;as
                                                            <FontAwesomeIcon icon="stream" className="ms-2" /></SoftBadge>&nbsp;
                                                    </Col>
                                                    <Col xs="auto">
                                                        {licencias.bIsActive &&
                                                            licencias.bIsPeriodoPrueba &&
                                                            !(licencias.idCatTipoLicencia == 7 && licencias.dDiasFaltantes > 0) &&
                                                            <IconButton
                                                                onClick={() => {
                                                                    if (licencias.idCatTipoLicencia == 7) {
                                                                        setShowModalAsignarDiasTipo7(true);
                                                                    } else {
                                                                        setShowModalAsignarDias(true);
                                                                    }
                                                                }}
                                                                iconClassName="fs--2"
                                                                variant="falcon-default"
                                                                size="sm"
                                                                icon="add"
                                                            >M&aacute;s d&iacute;as</IconButton>
                                                        }
                                                    </Col>
                                                </Row>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><strong>&Uacute;LTIMA CONEXI&Oacute;N:</strong></td>
                                            <td>{licencias.dUltimaConexion}</td>
                                        </tr>
                                        {licencias.vLatLon &&
                                            <tr>
                                                <td><strong>LAT. LONG.:</strong></td>
                                                <td><a href={"https://www.google.com/maps/place/" + licencias.vLatLon} target="_blank" rel="noreferrer">{licencias.vLatLon}</a></td>
                                            </tr>
                                        }
                                        {licencias.vLatLonSistema &&
                                            <tr>
                                                <td><strong>LAT. LONG. SISTEMA:</strong></td>
                                                <td><a href={"https://www.google.com/maps/place/" + licencias.vLatLonSistema} target="_blank" rel="noreferrer">{licencias.vLatLonSistema}</a></td>
                                            </tr>
                                        }
                                        <tr>
                                            <td><strong>UBICACI&Oacute;N:</strong></td>
                                            <td><a href={"https://www.google.com/maps/search/" + licencias.vEstadoDepProv + "+" + licencias.vPais} target="_blank" rel="noreferrer"> {licencias.vEstadoDepProv}, {licencias.vPais}</a> </td>
                                        </tr>
                                        {licencias.idCatTipoLicencia === 7 && licencias.vBD && (() => {
                                            try {
                                                const datosServidor = JSON.parse(licencias.vBD);
                                                return (
                                                    <>
                                                        {datosServidor.vServer && (
                                                            <tr>
                                                                <td><strong>SERVIDOR:</strong></td>
                                                                <td>{datosServidor.vServer}</td>
                                                            </tr>
                                                        )}
                                                        {datosServidor.vBD && (
                                                            <tr>
                                                                <td><strong>BASE DE DATOS:</strong></td>
                                                                <td>{datosServidor.vBD}</td>
                                                            </tr>
                                                        )}
                                                    </>
                                                );
                                            } catch (error) {
                                                console.error('Error al parsear vBD:', error);
                                                return null;
                                            }
                                        })()}
                                    </tbody>
                                </Table>
                                <hr></hr>
                                <Row className="align-items-center">
                                    <Col>
                                        {licencias.vComentarios &&
                                            <IconAlert className="mb-0" variant="warning">
                                                <p className="mb-0">{licencias.vComentarios}</p>
                                            </IconAlert>
                                        }

                                    </Col>
                                </Row>
                                <hr></hr>

                                {/*licencias.vConfiguracion &&
                                                    <>
                                                        <Row className="align-items-center">
                                                            <Col>
                                                                <h5 className="mb-0">Informaci&oacute;n adicional</h5>
                                                            </Col>
                                                        </Row>
                                                        <hr></hr>
                                                        <Table responsive striped hover size="sm" >
                                                            <tbody>
                                                                {licencias.vConfiguracion && Object.keys(JSON.parse(licencias.vConfiguracion)).map((key, i) => {
                                                                    return (
                                                                        <tr key={i}>
                                                                            <td>{key}</td>
                                                                            <td>{Object.values(JSON.parse(licencias.vConfiguracion))[i]}</td>
                                                                        </tr>
                                                                    )
                                                                })
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </>
                                                */}


                                {
                                    /*Si esta vinculada a un servidor*/
                                    (licencias.idCatTipoLicencia == 2 || licencias.idCatTipoLicencia == 4) ? (
                                        <>
                                            <Row className="align-items-center">
                                                <Col>
                                                    <h5 className="mb-0">
                                                        {(licencias.idCatTipoLicencia == 2 || licencias.idCatTipoLicencia == 4) ? "Servidor Conectado" : "Informaci&oacute;n adicional"}
                                                    </h5>
                                                </Col>
                                            </Row>
                                            <hr />
                                            {!showCambiarServidor ? (
                                                <>
                                                    {licencias.vConfiguracion ? (
                                                        <Table responsive striped hover size="sm">
                                                            <tbody>
                                                                {Object.entries(JSON.parse(licencias.vConfiguracion)).map(([key, value], index) => {
                                                                    const serverLic = servidoresDisponibles.find(srv => srv.vUUIDLicencia === value);
                                                                    const serverIdStr = serverLic ? ` (ID: ${serverLic.idLicencia})` : '';
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>SERVIDOR CONECTADO: </td>
                                                                            <td id={key}>{value}{serverIdStr}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </Table>
                                                    ) : (
                                                        <Row className="align-items-center mb-3">
                                                            <Col>
                                                                <span className="badge bg-danger" style={{ fontSize: "0.85rem" }}>
                                                                    No se encuentra vinculada a ningún servidor
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}

                                                    {licencias.bIsActive && (
                                                        <IconButton
                                                            onClick={() => { setShowCambiarServidor(true); obtenerServidoresActivosCliente(); }}
                                                            iconClassName="fs--2 me-1"
                                                            variant="falcon-default"
                                                            size="sm"
                                                            icon="pencil-alt"
                                                            className="mt-2"
                                                        >
                                                            Modificar Licencia Servidor
                                                        </IconButton>
                                                    )}
                                                </>
                                            ) : (
                                                <Form noValidate onSubmit={(e) => { e.preventDefault(); guardarNuevoServidor(); }}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Seleccionar Nueva Licencia Servidor</Form.Label>
                                                        {cargandoServidores ? (
                                                            <div className="py-2">
                                                                <Spinner animation="border" size="sm" className="me-2" />
                                                                Cargando servidores...
                                                            </div>
                                                        ) : (
                                                            <Form.Select
                                                                value={servidorSeleccionado}
                                                                onChange={(e) => setServidorSeleccionado(e.target.value)}
                                                            >
                                                                <option value="">-- Seleccionar Servidor --</option>
                                                                {servidoresDisponibles.map((srv, index) => (
                                                                    <option key={index} value={srv.vUUIDLicencia}>
                                                                        {srv.vNombreEmpresa ? `${srv.vNombreEmpresa} - ` : ''}{srv.vUUIDLicencia} (ID: {srv.idLicencia})
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        )}
                                                    </Form.Group>
                                                    <IconButton
                                                        onClick={() => { setShowCambiarServidor(false); }}
                                                        iconClassName="fs--2 me-1"
                                                        variant="falcon-default"
                                                        size="sm"
                                                        icon={faWindowClose}
                                                    >
                                                        Cancelar
                                                    </IconButton>
                                                    &nbsp;&nbsp;
                                                    <IconButton
                                                        type="submit"
                                                        iconClassName="fs--2 me-1"
                                                        variant="falcon-default"
                                                        size="sm"
                                                        icon="check"
                                                        disabled={!servidorSeleccionado || cargandoServidores}
                                                    >
                                                        Guardar
                                                    </IconButton>
                                                </Form>
                                            )}
                                        </>
                                    ) : (
                                        licencias.vConfiguracion ? (
                                            <>
                                                <Row className="align-items-center">
                                                    <Col>
                                                        <h5 className="mb-0">Informaci&oacute;n adicional</h5>
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Table responsive striped hover size="sm">
                                                    <tbody>
                                                        {Object.entries(JSON.parse(licencias.vConfiguracion)).map(([key, value], index) => (
                                                            <tr key={index}>
                                                                <td>{key}</td>
                                                                <td>{value}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </>
                                        ) : null
                                    )
                                }





                            </>

                        )
                    }

                </Card.Body>
                <Card.Footer className="border-top">
                    <ListGroup variant="flush">
                        {licencias.idCatTipoLicencia != 3 && licencias.idCatTipoLicencia != 7 &&
                            <ListGroup.Item>
                                {!showCambiarPCAutorizada &&
                                    <>
                                        <p>PC Autorizada:  {licencias.vDatosPCAutorizada ?
                                            <>
                                                <img src="/img/pcautorizada25.png"></img> {licencias.vDatosPCAutorizada}</>
                                            : <SoftBadge bg='danger' className='me-2'>NO ASIGNADA A PC</SoftBadge>}
                                        </p>

                                        {licencias.bIsActive &&
                                            <IconButton
                                                onClick={() => { setShowCambiarPCAutorizada(true); obtenerListaPCLogIn() }}
                                                iconClassName="fs--2 me-1"
                                                variant="falcon-default"
                                                size="sm"
                                                icon="pencil-alt"
                                            >
                                                Cambiar PC Autorizada
                                            </IconButton>
                                        }
                                    </>
                                }

                                {showCambiarPCAutorizada &&
                                    <>
                                        <Form noValidate onSubmit={handleSubmit(onSubmitAsignarPCAutorizada)}>
                                            <Form.Group className="mb-3" >
                                                <Form.Label>PC Disponibles</Form.Label>
                                                <Form.Select
                                                    aria-label="Default select"
                                                    defaultValue={licencias.vDatosPCAutorizada}
                                                    isInvalid={!!errors.vDatosPCAutorizada}
                                                    {...register("vDatosPCAutorizada")
                                                    }
                                                >
                                                    <option value="">Dejar en blanco</option>
                                                    {datosPCAutorizar.map((pc, index) => {
                                                        return (<option key={index} value={pc.vDatosPcLogIn}>{pc.vDatosPcLogIn} </option>)
                                                    })}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.vDatosPCAutorizada && errors.vDatosPCAutorizada.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <IconButton
                                                onClick={() => { setShowCambiarPCAutorizada(false); reset() }}
                                                iconClassName="fs--2 me-1"
                                                variant="falcon-default"
                                                size="sm"
                                                icon={faWindowClose}
                                            >
                                                Cancelar edici&oacute;n
                                            </IconButton>
                                            &nbsp;&nbsp;
                                            <IconButton
                                                type="submit"
                                                iconClassName="fs--2 me-1 "
                                                variant="falcon-default"
                                                size="sm"
                                                icon="check"
                                            >
                                                Guardar
                                            </IconButton>
                                        </Form>
                                    </>
                                }
                            </ListGroup.Item>
                        }
                    </ListGroup>
                </Card.Footer>
            </Card>

            {showModalAsignarDias &&
                <Modal
                    show={showModalAsignarDias}
                    onHide={() => setShowModalAsignarDias(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmitDias(onSubmitAsignarDias)}>
                        <Modal.Header>
                            <Modal.Title>Asignar d&iacute;as de Prueba</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalAsignarDias(false); resetDias(); }} />

                        </Modal.Header>
                        <Modal.Body>
                            El n&uacute;mero de d&iacute;as que desea asignar a la licencia por
                            <SoftBadge bg='danger' className='me-2'>PERIODO DE PRUEBA</SoftBadge>
                            Importante mencionar que esta cantidad se toma en cuenta apartir del d&iacute;a de hoy.

                            {(() => {
                                const numDias = parseInt(watchDias('iNumeroDias')) || 0;
                                const currDate = new Date();
                                const newDate = new Date();
                                newDate.setDate(currDate.getDate() + numDias);

                                const formatDate = (date) => {
                                    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
                                    return `${date.getDate().toString().padStart(2, '0')} ${months[date.getMonth()]} ${date.getFullYear()}`;
                                };

                                return (
                                    <p className="mt-3 mb-3 p-2 bg-light border rounded" style={{ fontSize: '0.85rem' }}>
                                        Ejemplo: Asignó {numDias} Días de Prueba a partir del <strong>{formatDate(currDate)}</strong>. Nueva fecha Vencimiento <strong>{formatDate(newDate)}</strong>.
                                    </p>
                                );
                            })()}

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <FloatingLabel
                                            label="Numero de d&iacute;as"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                name="iNumeroDias"
                                                type="number"
                                                defaultValue="5"
                                                min={1}
                                                max={licencias.idCatTipoLicencia == 7 ? 10 : 365}
                                                isInvalid={!!errorsDias.iNumeroDias}
                                                {...registerDias('iNumeroDias', {
                                                    required: 'Este campo solo acepta números',
                                                    valueAsNumber: true,
                                                    min: { value: 1, message: 'El mínimo es 1 día' },
                                                    max: {
                                                        value: licencias.idCatTipoLicencia == 7 ? 10 : 365,
                                                        message: licencias.idCatTipoLicencia == 7
                                                            ? 'El máximo permitido para esta licencia es 10 días'
                                                            : 'El máximo es 365 días'
                                                    }
                                                })}
                                                onInput={(e) => {
                                                    const maxVal = licencias.idCatTipoLicencia == 7 ? 10 : 365;
                                                    if (e.target.value !== '' && parseInt(e.target.value) > maxVal) e.target.value = maxVal;
                                                    if (e.target.value !== '' && parseInt(e.target.value) < 1) e.target.value = 1;
                                                }}
                                            />
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid" style={{ display: errorsDias.iNumeroDias ? 'block' : 'none' }}>
                                            {errorsDias.iNumeroDias && errorsDias.iNumeroDias.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowModalAsignarDias(false); }} variant='primary' >Cerrar</Button>
                            {procesandoModal ? <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button> :
                                <Button type="submit" variant='success'>Asignar d&iacute;as</Button>}
                        </Modal.Footer>
                    </Form>
                </Modal>
            }

            {showModalAsignarDiasTipo7 &&
                <Modal
                    show={showModalAsignarDiasTipo7}
                    onHide={() => { setShowModalAsignarDiasTipo7(false); resetDias(); }}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmitDias(onSubmitAsignarDias)}>
                        <Modal.Header>
                            <Modal.Title>Asignar d&iacute;as de Prueba</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalAsignarDiasTipo7(false); resetDias(); }} />
                        </Modal.Header>
                        <Modal.Body>
                            El n&uacute;mero de d&iacute;as que desea asignar a la licencia por
                            <SoftBadge bg='danger' className='me-2'>PERIODO DE PRUEBA</SoftBadge>
                            Importante mencionar que esta cantidad se toma en cuenta apartir del d&iacute;a de hoy.
                            <br />
                            <SoftBadge bg='warning' className='mt-2'>M&aacute;ximo permitido: 10 d&iacute;as</SoftBadge>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3 mt-3">
                                        <FloatingLabel
                                            label="Numero de d&iacute;as (m&aacute;x. 10)"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                name="iNumeroDias"
                                                type="number"
                                                defaultValue="5"
                                                min={1}
                                                max={10}
                                                isInvalid={!!errorsDias.iNumeroDias}
                                                {...registerDias('iNumeroDias', {
                                                    required: 'Este campo solo acepta números',
                                                    valueAsNumber: true,
                                                    min: { value: 1, message: 'El mínimo es 1 día' },
                                                    max: { value: 10, message: 'El máximo permitido para esta licencia es 10 días' }
                                                })}
                                                onInput={(e) => {
                                                    if (e.target.value !== '' && parseInt(e.target.value) > 10) e.target.value = 10;
                                                    if (e.target.value !== '' && parseInt(e.target.value) < 1) e.target.value = 1;
                                                }}
                                            />
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid" style={{ display: errorsDias.iNumeroDias ? 'block' : 'none' }}>
                                            {errorsDias.iNumeroDias && errorsDias.iNumeroDias.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowModalAsignarDiasTipo7(false); resetDias(); }} variant='primary'>Cerrar</Button>
                            {procesandoModal ? <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button> :
                                <Button type="submit" variant='success'>Asignar d&iacute;as</Button>}
                        </Modal.Footer>
                    </Form>
                </Modal>
            }

            {showModalActivar &&
                <Modal
                    show={showModalActivar}
                    onShow={ObtenerInformacionPolizasServidores}
                    onHide={() => setShowModalActivar(false)}
                    size="lg"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitActivar)}>
                        <Modal.Header>
                            <Modal.Title>Activar Licencia {licencias.vDescripcionTipo}</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { setShowModalActivar(false); reset() }} />

                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    Verifica y completa la siguiente informaci&oacute;n para activar la licencia.
                                    <hr></hr>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Fecha Inicio</Form.Label>

                                        <Form.Control
                                            type="date"
                                            {...register("dInicioLicenciaUso",
                                                {
                                                    required: true
                                                })
                                            }
                                            isInvalid={!!errors.dInicioLicenciaUso} />

                                        <Form.Control.Feedback type="invalid">
                                            {errors.dInicioLicenciaUso && errors.dInicioLicenciaUso.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Ciclo facturaci&oacute;n</Form.Label>
                                        <Form.Select
                                            aria-label="Default select"
                                            defaultValue={licencias.idCatCicloFacturacion}
                                            isInvalid={!!errors.idCatCicloFacturacion}
                                            {...register("idCatCicloFacturacion",
                                                {
                                                    required: true
                                                })
                                            }
                                        >
                                            {cicloFacturacion.map((ciclo, index) => {
                                                return (<option key={index} value={ciclo.idCatCicloFacturacion}>{ciclo.vDescripcionCiclo} - {ciclo.iNumeroDias} d&iacute;as</option>)
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.idCatCicloFacturacion && errors.idCatCicloFacturacion.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    {licencias.idCatTipoLicencia == 2 || licencias.idCatTipoLicencia == 4 ?
                                        (
                                            <>
                                                <Form.Group className="mb-3" >
                                                    <Form.Label>Elije el Servidor al que se vincula la Caja</Form.Label>
                                                    <Form.Select
                                                        aria-label="Default select"
                                                        isInvalid={!!errors.vUUIDLicenciaServidor}
                                                        {...register("vUUIDLicenciaServidor", {
                                                            required: 'La licencia Servidor es requerida',
                                                        })
                                                        }
                                                    >
                                                        <option value="">Elige Licencia Servidor</option>
                                                        {licenciasServidor.map((servidor, index) => {
                                                            return (<option key={index} value={servidor.vUUIDLicencia}> {servidor.bIsPeriodoPrueba && 'pp <<<'} {servidor.vUUIDLicencia}</option>)
                                                        })}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.vUUIDLicenciaServidor && errors.vUUIDLicenciaServidor.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </>
                                        )
                                        :
                                        (
                                            <>
                                                <Form.Group className="mb-3" >
                                                    <Form.Label>vLatLon <a href="https://www.google.com.mx/maps" rel="noreferrer" target="_blank">Abrir Google Maps</a></Form.Label>
                                                    <Form.Control
                                                        onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                        type="text"
                                                        autoComplete="off"
                                                        defaultValue={licencias.vLatLon}
                                                        placeholder="vLatLon"
                                                        isInvalid={!!errors.vLatLon}
                                                        {...register("vLatLon",
                                                            {
                                                                required: 'El vLatLon es requerido',
                                                                pattern: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/
                                                            })
                                                        }
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.vLatLon && errors.vLatLon.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className="mb-3" >
                                                    <Form.Label>P&oacute;liza Soporte Gratis</Form.Label>
                                                    <Form.Select
                                                        aria-label="Default select"
                                                        isInvalid={!!errors.idCatPolizaSoporte}
                                                        {...register("idCatPolizaSoporte", {
                                                            required: 'La poliza es requerida',
                                                        })
                                                        }
                                                    >
                                                        <option value="">Elige una p&oacute;liza</option>
                                                        {tipoPolizas.map((polizaType, index) => {
                                                            return polizaType.idCatTipoPoliza == 1 && (<option key={index} value={polizaType.idCatPoliza}>{polizaType.vNombrePoliza} - {polizaType.iNumeroDias} d&iacute;as</option>)
                                                        })}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.idCatPolizaSoporte && errors.idCatPolizaSoporte.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className="mb-3" >
                                                    <Form.Label>P&oacute;liza Actualizaciones Gratis</Form.Label>
                                                    <Form.Select
                                                        aria-label="Default select"
                                                        isInvalid={!!errors.idCatPolizaActualizaciones}
                                                        {...register("idCatPolizaActualizaciones", {
                                                            required: 'La poliza es requerida',
                                                        })
                                                        }
                                                    >
                                                        <option value="">Elige una p&oacute;liza</option>
                                                        {tipoPolizas.map((polizaType, index) => {
                                                            return polizaType.idCatTipoPoliza == 2 && (<option key={index} value={polizaType.idCatPoliza}>{polizaType.vNombrePoliza} - {polizaType.iNumeroDias} d&iacute;as</option>)
                                                        })}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.idCatPolizaActualizaciones && errors.idCatPolizaActualizaciones.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </>
                                        )}
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowModalActivar(false); reset() }} variant='primary' >Cerrar</Button>
                            {procesandoModal ? <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button> : <Button type="submit" variant='success' >A C T I V A R</Button>}
                        </Modal.Footer>
                    </Form>
                </Modal>
            }

            {showModalRenovar &&
                <ModalRenovarLicencia
                    licencias={licencias}
                    cicloFacturacion={cicloFacturacion}
                    idLicencia={idLicencia}
                    showModalRenovar={showModalRenovar}
                    setShowModalRenovar={setShowModalRenovar}
                    setPolizasRelacionadas={setPolizasRelacionadas}
                    usuariosNube={usuariosNube}
                    setUsuariosNube={setUsuariosNube}
                ></ModalRenovarLicencia>
            }

            {showModalActivarNube &&
                <ModalActivarNube
                    licencias={licencias}
                    cicloFacturacion={cicloFacturacion}
                    idLicencia={idLicencia}
                    setShowModalActivarNube={setShowModalActivarNube}
                    showModalActivarNube={showModalActivarNube}
                    usuariosNube={usuariosNube}
                    setUsuariosNube={setUsuariosNube}
                ></ModalActivarNube>
            }

            {showModalActivarAkasiaPOS &&
                <ModalActivarAkasiaPOS
                    licencias={licencias}
                    akasiaPOSWebPaquetes={akasiaPOSWebPaquetes}
                    idLicencia={idLicencia}
                    setShowModalActivarAkasiaPOS={setShowModalActivarAkasiaPOS}
                    showModalActivarAkasiaPOS={showModalActivarAkasiaPOS}
                ></ModalActivarAkasiaPOS>
            }

            {showModalDesactivar &&
                <ModalDesactivarLicencia
                    showModalDesactivar={showModalDesactivar}
                    setShowModalDesactivar={setShowModalDesactivar}
                    licencias={licencias}
                    idLicencia={idLicencia}
                    setPolizasRelacionadas={setPolizasRelacionadas}
                ></ModalDesactivarLicencia>
            }
        </>

    )
}

SeccionDatosLicencia.propTypes = {
    idLicencia: PropTypes.string.isRequired,
    licencias: PropTypes.object,

    procesandoModal: PropTypes.bool,
    setProcesandoModal: PropTypes.func,
    editar: PropTypes.bool,
    setEditar: PropTypes.func,


    getInformacionDetalladaLicenciaByID: PropTypes.func,

    vendedores: PropTypes.array,

    tipoLicencia: PropTypes.array,

    cicloFacturacion: PropTypes.array,

    setPolizasRelacionadas: PropTypes.func,

    usuariosNube: PropTypes.array,
    setUsuariosNube: PropTypes.func,

    akasiaPOSWebPaquetes: PropTypes.array,

    infoSuscripcion: PropTypes.object
};

export default SeccionDatosLicencia;

